// extracted by mini-css-extract-plugin
module.exports = {"host":"Menu_host__G2Gxo"};